// Practice for build-in-stages OAs (CodeSignal's Industry Coding Framework):
// one small system, built level by level, each level adding to the last
// without breaking it. Our own exercises, in the spirit of the format, not
// copies of real tasks. Each session is two levels; the timed mock is a whole
// system in 90 minutes.

export type BuildSystem = {
  id: string;
  name: string;
  /** Four levels, each building on the one before */
  levels: [string, string, string, string];
};

export const BUILD_SYSTEMS: BuildSystem[] = [
  {
    id: "kv-store",
    name: "In-memory key-value store",
    levels: [
      "set, get and delete fields on records",
      "list a record's fields, filtered by prefix and sorted",
      "values that expire after a time-to-live",
      "read a record as it was at an earlier timestamp",
    ],
  },
  {
    id: "bank",
    name: "Bank accounts",
    levels: [
      "create accounts, deposit and transfer, rejecting bad requests",
      "rank accounts by money moved out",
      "scheduled payments that run at a timestamp, and cancelling them",
      "merge two accounts, keeping their history",
    ],
  },
  {
    id: "file-store",
    name: "Cloud file storage",
    levels: [
      "add, read and delete files with sizes",
      "find the largest files under a path prefix",
      "users with storage limits",
      "back up a user's files and restore them later",
    ],
  },
  {
    id: "task-queue",
    name: "Task scheduler",
    levels: [
      "add tasks with priorities and pop the next one",
      "list tasks by owner, sorted by priority then age",
      "tasks that can't start until others finish",
      "undo the last few changes",
    ],
  },
];

/** One practice session: two levels of a system */
export type BuildSession = { system: BuildSystem; from: 1 | 3 };

/** Every session in order: each system's levels 1–2, then 3–4 */
export const BUILD_SESSIONS: BuildSession[] = BUILD_SYSTEMS.flatMap((system) => [
  { system, from: 1 as const },
  { system, from: 3 as const },
]);
